import React, { useContext, useEffect, useRef, useState } from "react";
import NavSub from "../components/NavSub";
import ToastComponent from "../components/ToastComponent";
import { clientApiUrl } from "../utils/GetUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../Styles/ActivitywisetimereportNav.css";
import "../Styles/UserwiseTimeReportNav.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { UserContext } from "../context/UserContext";
import { Download } from "phosphor-react";
import * as XLSX from "xlsx";
import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  InputLabel,
} from "@mui/material";
import { AuthContext } from "../context/AuthContext";
import ActivityWise21 from "../components/ActivityWise21";

function ReportSynergyTotalTime() {
  const [timeCodes, setTimeCodes] = useState([]);
  const [totalTime, setTotalTime] = useState(0);
  const [difference, setDifference] = useState(0);
  const { teamNames, usersList } = useContext(UserContext);
  const { token, logout, handleAuthExpiry, userData } = useContext(AuthContext);
  const [chosenDate, setChosenDate] = useState("");
  const [teams, setTeams] = useState(
    teamNames?.filter(
      (team) =>
        team?.superTeamId === 0 && team?.type === "T" && team?.status === true
    )
  );
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [timeCode, setTimeCode] = useState(null);
  const [department, setDepartment] = useState(null);
  const [uniqueDepartments, setUniqueDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedIds, setSelectedIds] = useState("");
  const [selectedCostCenters, setSelectedCostCenters] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [uniqueTimeCodes, setUniqueTimeCodes] = useState([]);
  const [selectedTimeCode, setSelectedTimeCode] = useState("");
  const [selectedTimeCodeIds, setSelectedTimeCodeIds] = useState("");
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [processedData, setProcessedData] = useState([]);

  const [accountResponsible, setAccountResponsible] = useState([]);
  const [accountResponsible2, setAccountResponsible2] = useState([]);
  const [selectedClient, setSelectedClient] = useState({});
  const [selectedAccountResponsible, setSelectedAccountResponsible] = useState(
    []
  );
  const [isAccountResponsibleOpen, setIsAccountResponsibleOpen] =
    useState(false);
  const dropdownsearchRef = useRef(null);
  const [accSearch, setAccSearch] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedPrepareName, setSelectedPrepareName] = useState(null);

  const handleAccountingResponsibleClick = () => {
    setIsAccountResponsibleOpen((prevState) => !prevState);
    setdatebellDropdownOpen(false);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  useEffect(() => {
    if (selectedTeams.length === 0 && !selectedPrepareName) {
      setSelectedEmployees([]);
    }
  }, [usersList, selectedTeams, selectedPrepareName]);

  useEffect(() => {
    setTeams(
      teamNames?.filter(
        (team) =>
          team?.superTeamId === 0 && team?.type === "T" && team?.status === true
      )
    );
  }, [teamNames]);

  const currentDate = new Date();
  const currentMonthYear = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1
  ).padStart(2, "0")}`;

  const [selectedDate, setSelectedDate] = useState(currentMonthYear);

  const isOpen = Boolean(anchorEl);

  const handleProceed = () => {
    setChosenDate(selectedDate);
    setdatebellDropdownOpen(false);
  };

  const [isdateDropdownOpen, setdatebellDropdownOpen] = useState(false);
  const [isDateDropdownOpen, setIsDateDropdownOpen] = useState(false);
  const dropdown2Ref = useRef(null);

  const closeDateDropdown = () => {
    setdatebellDropdownOpen(false);
  };

  useEffect(() => {
    const handleClick2Outside = (event) => {
      if (
        dropdown2Ref.current &&
        !dropdown2Ref.current.contains(event.target)
      ) {
        setdatebellDropdownOpen(false);
      }
    };

    const handleScroll = () => {
      closeDateDropdown();
    };

    document.addEventListener("mousedown", handleClick2Outside);
    window.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("mousedown", handleClick2Outside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleDateDropdown = () => {
    setdatebellDropdownOpen(!isdateDropdownOpen);
    setIsDateDropdownOpen(!isDateDropdownOpen);
    setIsAccountResponsibleOpen(false);
  };

  const handleChange = (event) => {
    if (event.target.value[event.target.value?.length - 1] === undefined) {
      setSelectedTeams([]);
      setSelectedPrepareName(null);
      return;
    }
    setSelectedTeams(event.target.value);
    setSelectedPrepareName(null);
  };

  useEffect(() => {
    const uniqueNames = [...new Set(department?.map((dept) => dept.name))];
    setUniqueDepartments(uniqueNames);
  }, [department]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeptChange = (event) => {
    const name = event.currentTarget.getAttribute("data-value");
    setSelectedDepartment(name);

    const ids = department
      ?.filter((dept) => dept.name === name)
      .map((dept) => dept.id)
      .join(",");
    setSelectedIds(ids);
    const costCenters = department
      ?.filter((dept) => dept.name === name)
      .map((dept) => `'${dept.costCenter}'`)
      .join(",");
    setSelectedCostCenters(costCenters);
    handleClose();
  };

  useEffect(() => {
    const uniqueCodes = [
      ...new Set(timeCode?.map((code) => code.AL_SalseforceCode)),
    ];
    setUniqueTimeCodes(uniqueCodes);
  }, [timeCode]);

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const toastRef = useRef();

  const fetchDepartments = async () => {
    try {
      const response = await fetch(
        `${clientApiUrl}/GetAllDepartment?Page=1&ItemsPerPage=500`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }
      if (response.ok) {
        const data = await response.json();
        setDepartment(data);
      } else {
        console.error("Network response was not ok");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchTimeCode = async () => {
    try {
      const response = await fetch(
        `${clientApiUrl}/GetAllActivity?Page=1&ItemsPerPage=500`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }
      if (response.ok) {
        const data = await response.json();
        setTimeCode(data?.filter((item) => item?.AL_Status == "1"));
      } else {
        console.error("Network response was not ok");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchDepartments();
      fetchTimeCode();
    }
  }, [token]);

  const handleCheckboxAccountResponsibleChange = (acc) => {
    setSelectedOption({});

    if (selectedPrepareName?.EM_ID === acc.EM_ID) {
      setSelectedPrepareName(null);
      setSelectedAccountResponsible([]);
      setSelectedEmployees([]);
      setSelectedTeams([]);
      return;
    }

    if (selectedTeams?.length) {
      setSelectedTeams([]);
    }

    setSelectedAccountResponsible([acc]);
    setSelectedPrepareName(acc);
    setSelectedEmployees([acc]);
    setSelectedClient([]);
  };

  useEffect(() => {
    setAccountResponsible(usersList);
    setAccountResponsible2(usersList);
  }, [usersList]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownsearchRef.current &&
        !dropdownsearchRef.current.contains(event.target) &&
        !event.target.closest(".Title-STR-main2")
      ) {
        setIsAccountResponsibleOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Download Excel function
  const handleDownloadExcel = () => {
    // Check if we have filters applied but no data
    if (
      (selectedTeams.length > 0 || selectedPrepareName) &&
      processedData.length === 0
    ) {
      toastRef.current.showToast("Data is still loading, please wait", "info");
      return;
    }

    // Check if no filters are applied and no data
    if (
      selectedTeams.length === 0 &&
      !selectedPrepareName &&
      processedData.length === 0
    ) {
      toastRef.current.showToast("Please apply filters to get data", "error");
      return;
    }

    try {
      // Get all unique time codes from the timeCode prop
      const scrollableTimeCodes = processedData.length
        ? Object.keys(processedData[0])
            .filter(
              (key) =>
                ![
                  "emId",
                  "emName",
                  "emTeam",
                  "emSynergyHours",
                  "emTotalTime",
                  "emDiff",
                  "internal9000Billable",
                  "internal9114NonBillable",
                ].includes(key)
            )
            .filter((key) => {
              // Only include keys that are uppercase (normalized time codes)
              return (
                key === key.toUpperCase() &&
                !key.startsWith("9000") &&
                !key.startsWith("9114")
              );
            })
        : [];

      // Prepare worksheet data
      const wsData = [
        [
          "Employee",
          "Team",
          ...scrollableTimeCodes,
          "9000 internal billable",
          "9114 Synergy Internal time",
          "Total Synergy Hours",
          "Total Reported Hours in VF",
          "Difference",
        ],
        ...processedData.map((item) => [
          item.emName,
          item.emTeam,
          ...scrollableTimeCodes.map((code) => item[code] || 0),
          item.internal9000Billable || 0,
          item.internal9114NonBillable || 0,
          item.emSynergyHours || 0,
          item.emTotalTime || 0,
          item.emDiff || 0,
        ]),
      ];

      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet(wsData);

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SynergyTotalTimeReport");

      // Generate file name
      const fileName = `Synergy_Total_Time_Report_${
        selectedDate || currentMonthYear
      }_${new Date().getTime()}.xlsx`;

      // Download the file
      XLSX.writeFile(wb, fileName);

      toastRef.current.showToast("Report downloaded successfully", "success");
    } catch (error) {
      console.error("Error downloading Excel:", error);
      toastRef.current.showToast("Error downloading report", "error");
    }
  };

  return (
    <div className="back-design">
      <NavSub />
      <ToastComponent ref={toastRef} timeout={4000} />
      <div className="flex justify-between items-center bg-white p-3 mb-4 ">
        <div className="flex items-center gap-2 ">
          <FormControl
            className={`select-dropdown-user ${
              selectedPrepareName ? "disabled-filter" : ""
            }`}
          >
            <InputLabel
              id="team-selector-label"
              className="select-dropdown-label"
              shrink={false}
            >
              SELECT TEAMS
              <div className="caret-icon-user"></div>
            </InputLabel>

            <Select
              labelId="team-selector-label"
              id="team-selector"
              className="dev-select-change "
              multiple
              value={selectedTeams}
              onChange={handleChange}
              disabled={!!selectedPrepareName}
              renderValue={(selected) =>
                selected.length === 0
                  ? "SELECT TEAMS"
                  : selected
                      .map((teamId) => {
                        const team = teams.find((team) => team.id === teamId);
                        return team?.Name;
                      })
                      .join(", ")
              }
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 250,
                  },
                },
              }}
              sx={{ width: 150 }}
            >
              {selectedTeams?.length > 0 && (
                <MenuItem onClick={() => setSelectedTeams([])}>
                  <ListItemText style={{ color: "red" }} primary={"Clear"} />
                </MenuItem>
              )}
              {teams.map((team) => (
                <MenuItem key={team.id} value={team.id}>
                  <Checkbox checked={selectedTeams.indexOf(team.id) > -1} />
                  <ListItemText primary={team.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <div
            className={`Title-STR-main2 ${
              selectedTeams.length > 0 ? "disabled-filter" : ""
            }`}
            onClick={handleAccountingResponsibleClick}
          >
            {selectedPrepareName
              ? `${selectedPrepareName.EM_FirstName} ${selectedPrepareName.EM_LastName}`
              : "Preparer Name"}
            <FontAwesomeIcon
              className="str-caret-icon"
              icon={isAccountResponsibleOpen ? faCaretUp : faCaretDown}
            />
            {isAccountResponsibleOpen && (
              <div ref={dropdownsearchRef} className="search-drop-DailyVoucher">
                <div className="search-drop-page">
                  <div className="main-suggestion">
                    <div className="input-suggestion">
                      <div className="icon-search-phospher">
                        <MagnifyingGlass
                          size={20}
                          color="#ada4a4"
                          weight="fill"
                        />
                      </div>
                      <input
                        type="text"
                        value={accSearch}
                        className="input-suggestion-search"
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          const value = e.target.value.toLowerCase();
                          setAccSearch(value);
                          setAccountResponsible2(
                            accountResponsible?.filter((acc) =>
                              (acc.EM_FirstName + " " + acc?.EM_LastName)
                                .toLowerCase()
                                .includes(value)
                            )
                          );
                        }}
                        placeholder="Start typing..."
                      />
                    </div>
                    <div tabIndex={1}>
                      <div
                        style={{ color: "red", padding: "2px 22px" }}
                        onClick={() => {
                          setSelectedPrepareName(null);
                          setSelectedAccountResponsible([]);
                          setSelectedEmployees([]);
                        }}
                      >
                        Clear All
                      </div>
                      {accountResponsible2?.map((acc) => (
                        <div key={acc.EM_ID} className="suggestion-list-li">
                          <input
                            type="radio"
                            className="radio-searchbox"
                            style={{
                              accentColor: "rgb(80, 20, 90)",
                              width: "18px",
                              height: "18px",
                            }}
                            checked={selectedPrepareName?.EM_ID === acc.EM_ID}
                            onChange={() =>
                              handleCheckboxAccountResponsibleChange(acc)
                            }
                          />
                          <label className="li-content">
                            {acc.EM_FirstName + " " + acc.EM_LastName}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2 ">
          <div className="Voucher-cust-name" onClick={toggleDateDropdown}>
            MONTH RANGE
            {isdateDropdownOpen ? (
              <ArrowDropUpIcon style={{ marginLeft: "8px" }} />
            ) : (
              <ArrowDropDownIcon style={{ marginLeft: "8px" }} />
            )}
          </div>
          <div className="cust_common_btn" onClick={handleDownloadExcel}>
            <Download weight="fill" size={20} /> DOWNLOAD
          </div>
        </div>

        {isdateDropdownOpen && (
          <div
            ref={dropdown2Ref}
            className="absolute mt-[200px] right-[5.75rem] z-10 bg-white shadow-lg rounded-lg p-4 w-72"
          >
            <div className="mb-3 text-sm font-medium text-gray-700">
              Select A Custom Month Of Your Choice
            </div>
            <input
              type="month"
              value={selectedDate}
              onChange={handleDateChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
            <button
              onClick={handleProceed}
              className="w-full bg-purple-600 text-white py-2 rounded-md hover:bg-purple-700 transition"
            >
              PROCEED
            </button>
          </div>
        )}
      </div>
      <div className="flex justify-center">
        <div className="w-[60%] bg-white text-center text-[#50145A] font-poppins text-[12px] font-semibold uppercase p-2 rounded-md">
          ACTIVITIES
        </div>
      </div>

      <ActivityWise21
        processedData={processedData}
        setProcessedData={setProcessedData}
        selectedIds={selectedIds}
        selectedTimeCode={selectedTimeCode}
        timeCode={timeCode}
        selectedDate={chosenDate}
        teams={teams}
        selectedTeams={selectedTeams}
        setSelectedTeams={setSelectedTeams}
        selectedEmployees={selectedEmployees}
        selectedPrepareName={selectedPrepareName}
        setSelectedPrepareName={setSelectedPrepareName}
        setSelectedClient={setSelectedClient}
      />
    </div>
  );
}

export default ReportSynergyTotalTime;
